import { CycleType } from '../types';

/**
 * Returns the OKR result column label for the active appraisal cycle.
 * Keep the END label as the fallback to match the existing self-appraisal UI.
 */
export const getOkrResultColumnLabel = (cycleType?: number): string =>
  cycleType === CycleType.MID ? 'Mid Year Result' : 'End Year Result';
